import { NovaConversation } from './NovaConversation';
import { NovaPaper } from './NovaPaper';
import { useNovaAgentStore } from '../../store/useNovaAgentStore';

export function NovaWorkspace({
  onBack,
  hideBack = false,
}: {
  onBack?: () => void;
  hideBack?: boolean;
}) {
  const creation = useNovaAgentStore((s) => s.creation);
  const kind = useNovaAgentStore((s) => s.kind);
  const sheet = useNovaAgentStore((s) => s.sheet);

  if (!creation) {
    return <NovaConversation onBack={onBack} hideBack={hideBack} />;
  }

  return (
    <div className="flex flex-1 min-h-0 min-w-0">
      <div className="w-[22rem] max-w-[40%] shrink-0 border-r border-neutral-200 flex flex-col min-h-0">
        <NovaConversation onBack={onBack} hideBack={hideBack} />
      </div>
      <div className="flex-1 min-w-0 overflow-auto bg-neutral-100 p-6 flex">
        <NovaPaper kind={kind} sheet={sheet} />
      </div>
    </div>
  );
}
